import {
  Inbox, GitBranch, Users, Boxes,
  PieChart, BarChart3, MessageSquare, CheckSquare, AlertTriangle, ScrollText, Truck, Workflow,
} from "lucide-react";
import { ListChecks } from "lucide-react";

// Aug 2026 Operations dashboard scope pass (items 2/3) — "Work Queue" is
// removed from the Operations nav (mirrors the earlier Finance nav
// consolidation: /operations/tasks stays mounted in App.js and reachable by
// direct URL/deep link, it is just unlinked from the sidebar) and replaced
// with "Pipeline" (frontend/src/pages/ops/Pipeline.jsx), which categorizes
// every Job by its current Operations stage the same way Sales/Finance
// Pipeline already group their own cases by stage.

// Navigation per role. Order matters (first = default landing).
export const NAV = {
  sales: [
    { to: "/sales/inbox", label: "My Day", icon: Inbox },
    { to: "/sales/messages", label: "Messages", icon: MessageSquare },
    { to: "/sales/pipeline", label: "Pipeline", icon: GitBranch },
    { to: "/sales/customers", label: "Customers", icon: Users },
  ],
  operations: [
    { to: "/operations/inbox", label: "My Day", icon: Inbox },
    { to: "/operations/pipeline", label: "Pipeline", icon: Workflow },
    { to: "/operations/messages", label: "Messages", icon: MessageSquare },
    { to: "/operations/jobs", label: "Jobs", icon: Boxes },
    { to: "/operations/exceptions", label: "Exceptions", icon: AlertTriangle },
  ],
  finance: [
    { to: "/finance/inbox", label: "My Day", icon: Inbox },
    { to: "/finance/messages", label: "Messages", icon: MessageSquare },
    { to: "/finance/pipeline", label: "Pipeline", icon: Workflow },
    { to: "/finance/approvals", label: "Approvals", icon: CheckSquare },
    { to: "/finance/exceptions", label: "Exceptions", icon: AlertTriangle },
    { to: "/finance/profitability", label: "Profitability", icon: PieChart },
  ],
  management: [
    { to: "/management/inbox", label: "My Day", icon: Inbox },
    { to: "/management/tasks", label: "Team Work Queue", icon: ListChecks },
    { to: "/management/approvals", label: "Approvals", icon: CheckSquare },
    { to: "/management/exceptions", label: "Exceptions", icon: AlertTriangle },
    { to: "/management/messages", label: "Messages", icon: MessageSquare },
    { to: "/management/audit", label: "Audit Log", icon: ScrollText },
    { to: "/management/suppliers", label: "Supplier Directory", icon: Truck },
  ],
  analytics: [
    { to: "/analytics", label: "Performance", icon: BarChart3 },
  ],
};

export const DEFAULT_ROUTE = {
  sales: "/sales/inbox",
  operations: "/operations/inbox",
  finance: "/finance/inbox",
  management: "/management/inbox",
  analytics: "/analytics",
};

export const roleFromPath = (pathname) => {
  const seg = pathname.split("/")[1];
  return ["sales", "operations", "finance", "management", "analytics"].includes(seg) ? seg : "sales";
};
